module.exports = __webpack_public_path__ + "img/bend_logo_navy_blue.d785b189.svg";